import {executeInlineScripts} from "@otto-ec/global-resources/hardcore";

export class ConnectFour {

    async init() {
        const connectFourElement: HTMLElement | null = document.querySelector('.promo_staticcontent--connect-four');
        if (connectFourElement) {
            await fetch("/4gewinnt/content.html").then(response => {
                if (response.ok) {
                    return response.text();
                } else {
                    throw new Error("[FT3] Connect Four loading failed.");
                }
            }).then(connectFourHtml => {
                connectFourElement.innerHTML = connectFourHtml;

                if (connectFourElement.querySelectorAll("script").length > 0) {
                    executeInlineScripts(connectFourElement);
                }
                window.invokePreload.processPreloadsOnElement(connectFourElement);
            }).catch(error => {
                console.error(error.message);
            })
        } else {
            console.error("[FT3] Connect Four element not found.");
        }
    }

}